import React, { memo } from 'react';
import _get from 'lodash/get';

import { CanRoute } from 'utils';
import { useRouter } from './context';
import { createAccessKey } from './utils';

function RouterRoute({
  path = '',
  exact = false,
  accessPath = [],
  isBlocked = false,
  component: Component
}) {
  const { rootPath, rootAccessPath } = useRouter();

  const completeAccessPath = [...rootAccessPath, ...accessPath];
  const accessId = createAccessKey(completeAccessPath);
  // const accessId = `${completeAccessPath.join('.submenu.')}.enabled`;

  return (
    <CanRoute
      accessId={accessId}
      path={path}
      exact={exact}
      component={Component}
      isBlocked={isBlocked}
      redirectPath={rootPath}
    />
  );
}

export default memo(RouterRoute, (prevProps, nextProps) => {
  const prevAccessPaths = _get(prevProps, 'accessPath', []);
  const nextAccessPaths = _get(nextProps, 'accessPath', []);
  return (
    prevProps.path === nextProps.path &&
    prevProps.exact === nextProps.exact &&
    prevProps.isBlocked === nextProps.isBlocked &&
    prevProps.component === nextProps.component &&
    prevAccessPaths.join() === nextAccessPaths.join()
  );
});
